import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollCardDirective } from './scroll-card.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ScrollCardDirective],
  exports: [ScrollCardDirective]
})
export class ScrollCardModule { }
